import React, { useEffect } from 'react';
import { Row, Col } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

import HomeScreenBox from './home-screen-box';

import StudentIcon from 'img/home-screen/students.svg';
import ContactUsIcon from 'img/home-screen/contact-us.svg';
import TeachersIcon from 'img/home-screen/teachers.svg';
import CurriculmIcon from 'img/home-screen/curriculum.svg';
import CurriculmAnalyticsIcon from 'img/home-screen/curriculum-analytics.svg';
import StudentDemoIcon from 'img/home-screen/student-demo.svg';
import StudentPaymentIcon from 'img/home-screen/student-payment.svg';
import PricingManagementIcon from 'img/home-screen/pricing-management.svg';
import PaymentLinkIcon from 'img/home-screen/payment-link.svg';
import TrainingIcon from 'img/home-screen/training.svg';
import TeacherClassroomIcon from 'img/home-screen/teacher-classroom.svg';
import TeacherApplicatinSVG from 'img/home-screen/teacher-application.svg';
import WorkbookManagementSVG from 'img/home-screen/workbook-management.svg';
import LearnosityItemsUpdatedSVG from 'img/home-screen/learnosity-items.svg';
import StudentTransferSVG from 'img/home-screen/student-transfer.svg';
import RmPORTALIcon from 'img/home-screen/rm-portal.svg';
import CustomerSupportSVG from 'img/home-screen/customer-support.svg';
import AutomatedMappingSVG from 'img/home-screen/automated-mapping.svg';
import UserVibes from 'img/home-screen/user-vibes.svg';
import TrialDashboardIcon from 'img/home-screen/student-demo.svg';

import { trackEvent } from 'modules/analytics';
import { EVENT_TYPE } from 'constants/logger';
import useAVReviewRole from 'screens/av-review-dashboard/hooks/use-av-review-role';
import { useCheckInternalTicketAccess } from 'actions/internal-tickets';

const Root = styled(Col)`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MenuRow = styled(Row)`
  width: ${({ width }) => (width ? width : '1070px')};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '24px')};
  gap: 32px;
  margin-bottom: 32px;
`;

const adminDashboardOptions = [
  {
    label: 'Students',
    icon: StudentIcon,
    link: '/students',
  },
  {
    label: 'Contact Info',
    icon: ContactUsIcon,
    link: '/pii-info',
  },
  {
    label: 'Teachers',
    icon: TeachersIcon,
    link: '/users/teachers',
  },
  {
    label: 'Teacher Applicants',
    icon: TeacherApplicatinSVG,
    link: '/users/teacher-applicants',
  },
  {
    label: 'Teacher Classroom',
    icon: TeacherClassroomIcon,
    link: '/users/teacher-classrooms',
  },
  {
    label: 'Curriculum',
    icon: CurriculmIcon,
    link: '/curriculum-graph',
  },
  {
    label: 'Student Demos',
    icon: StudentDemoIcon,
    link: '/users/studentdemos',
  },
  {
    label: 'Payment Link',
    icon: PaymentLinkIcon,
    link: '/users/payments',
  },
  {
    icon: TrainingIcon,
    link: '/users/training-accounts',
    label: 'Training Accounts',
  },
  {
    label: 'Curriculum Analytics',
    icon: CurriculmAnalyticsIcon,
    link: '/curriculum-analytics',
  },
  {
    label: 'Student Payment',
    icon: StudentPaymentIcon,
    link: '/student-payments',
  },
  {
    label: 'Pricing Management',
    icon: PricingManagementIcon,
    link: '/pricing-management',
  },
  {
    label: 'User Vibes',
    icon: UserVibes,
    link: '/user-vibe',
  },
  {
    label: 'Automated Mapping',
    icon: AutomatedMappingSVG,
    link: '/auto-mapping',
  },
  {
    label: 'Workbook Management',
    icon: WorkbookManagementSVG,
    link: '/workbook-management',
  },
  {
    label: 'Learnosity Item Updated',
    icon: LearnosityItemsUpdatedSVG,
    link: '/learnosity-item-updated',
  },
  {
    label: 'Student Transfer',
    icon: StudentTransferSVG,
    link: '/student-transfer',
  },
  {
    label: 'Customer Support Utils',
    icon: CustomerSupportSVG,
    link: '/cs-utils',
  },
  {
    label: 'Customer Success Managers',
    icon: RmPORTALIcon,
    link: 'users/csm',
  },
  {
    label: 'Classroom Analysis Hub',
    icon: TrialDashboardIcon,
    link: '/classroom-dashboard',
  },
  {
    label: 'AV Review Dashboard',
    icon: TeacherClassroomIcon,
    link: '/av-reviews',
  },
  //Todos: will enable in some time for ac
  // {
  //   label: 'AC Led Mapping',
  //   icon: RmPORTALIcon,
  //   link: '/ac-led-mapping',
  // },
  // {
  //   label: 'AC Led Mapping V2',
  //   icon: RmPORTALIcon,
  //   link: '/ac-led-mapping/V2',
  // },
];

const INTERNAL_TICKETS_OPTION = {
  label: 'Internal Tickets',
  icon: CustomerSupportSVG,
  link: '/internal-tickets',
};

function Home() {
  const { data: accessData, get: checkAccess } = useCheckInternalTicketAccess();

  useEffect(() => {
    trackEvent(EVENT_TYPE.HOME_SCREEN_VIEW);
  }, []);

  useEffect(() => {
    checkAccess('check');
  }, [checkAccess]);

  const hasInternalTicketsAccess = accessData?.has_access === true;

  const dashboardOptions = hasInternalTicketsAccess
    ? [...adminDashboardOptions, INTERNAL_TICKETS_OPTION]
    : adminDashboardOptions;

  return (
    <Root>
      <Text variant="h4">Cuemath Admin</Text>
      <MenuRow>
        {dashboardOptions.map(dashboardItem => {
          const { label, icon, link } = dashboardItem;

          return (
            <HomeScreenBox
              key={`${label}_${link}`}
              label={label}
              icon={icon}
              link={link}
            />
          );
        })}
      </MenuRow>
    </Root>
  );
}

export default Home;
